import { FormatStringByWordLength } from "../../shared/scripts/array-functions";


export class UserDirectoryEntity {
    
    FirstName: string;
    LastName: string;
    Email: string;
    ResearchHub: string;
    Role: string;
    Institution: string;
    CONNECT_Workgroup: string[];


    SortName: string;
    DisplayName: string;
    DisplayEmail: string = "";
    WorkgroupDisplay: string = "";

    initialize(): void {
        this.DisplayName = this.FirstName + " " + this.LastName;
        if (this.LastName == "Brinkley-Rubinstein") {
            this.ResearchHub = "INTERACT Center | " + this.ResearchHub;
        }
        this.DisplayName = FormatStringByWordLength(this.DisplayName, 4);
        this.SortName = this.LastName + " " + this.FirstName;

        if (this.Email?.length > 0) {
            this.DisplayEmail = "<a href='mailto:" + this.Email + "'><span class='nowrap'>" + this.Email.toLowerCase() + "<i class='fa fa-envelope link-icon' aria-hidden='true'></i></span></a>";
            //this.DisplayName = "<a href='mailto:" + this.Email + "'><span class='nowrap'>" + this.DisplayName + "</span></a>";
        }

        if (this.CONNECT_Workgroup?.length > 0) {
            this.WorkgroupDisplay = this.CONNECT_Workgroup.join(" | ");
        }
    }
}